
export const environment = {
   production: true,
   google: {
      GA_TRACKING_ID: 'G-50J7YSZJ00'
   },
   api: 'https://backend.sound-buttons.click/api',
   origin: 'https://sound-buttons.click',
   version: '8801cad5f29ab47bde7b16aec31d94a74014ba60',
   CLARITY_TRACKING_ID: 'jnas47yqmj',
   CLOUDFLARE_RUM_TOKEN: ''
};
